// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_57-0";
export var orangeButton = "_57-1";